const _shelfkey = 'kkComicMyShelf'
const _historykey = 'kkComicReadHistory'

const _shelfkey_novel = 'kkComicMyShelfNovel'
const _historykey_novel = 'kkComicReadHistoryNovel'

function setShelf(shelf) {
  window.localStorage.setItem(_shelfkey, JSON.stringify(shelf));
}

function setHistory(history) {
  window.localStorage.setItem(_historykey, JSON.stringify(history));
}

function setShelfNovel(shelf) {
  window.localStorage.setItem(_shelfkey_novel, JSON.stringify(shelf));
}

function setHistoryNovel(history) {
  window.localStorage.setItem(_historykey_novel, JSON.stringify(history));
}


let shelfService = {

  addShelf(bookInfo) {
    let res = false;
    let shelf = this.getShelf();
    if(shelf.find(item => { return item.title === bookInfo.title; })) {
      shelf = shelf.filter(item => item.title !== bookInfo.title);
    }
    else {
      shelf.push(bookInfo);
      res = true;
    }
    setShelf(shelf);
    return res;
  },
  getShelf() {
    let shelf = JSON.parse(window.localStorage.getItem(_shelfkey));
    if(shelf) {
      return shelf;
    }
    else {
      return [];
    }
  },


  addHistory(bookInfo, number) {
    let history = this.getHistory();
    let h = history.find(item => {return item.bookInfo.bookId.toString() === bookInfo.bookId.toString()});
    let hIndex = history.findIndex(item => item.bookInfo.title === bookInfo.title);
    if(h) {
      if(h.number !== number) {
        h.number = number;
        history.splice(hIndex, 1, h);
      }
    }
    else {
      history.push({bookInfo, number: number, date: new Date()});
    }
    setHistory(history);
  },
  getHistory() {
    let history = JSON.parse(window.localStorage.getItem(_historykey));
    if(history) {
      return history.sort((a, b) => {
        let da = new Date(a.date);
        let db = new Date(b.date);
        return db - da;
      })
    }
    else {
      return [];
    }
  },


  addShelfNovel(bookInfo) {
    let res = false;
    let shelf = this.getShelfNovel();
    if(shelf.find(item => { return item.title === bookInfo.title; })) {
      shelf = shelf.filter(item => item.title !== bookInfo.title);
    }
    else {
      shelf.push(bookInfo);
      res = true;
    }
    setShelfNovel(shelf);
    return res;
  },
  getShelfNovel() {
    let shelf = JSON.parse(window.localStorage.getItem(_shelfkey_novel));
    if(shelf) {
      return shelf;
    }
    else {
      return [];
    }
  },
  
  addHistoryNovel(bookInfo, number) {
    let history = this.getHistoryNovel();
    let h = history.find(item => {return item.bookInfo.bookId.toString() === bookInfo.bookId.toString()});
    let hIndex = history.findIndex(item => item.bookInfo.title === bookInfo.title);
    if(h) {
      if(h.number !== number) {
        h.number = number;
        history.splice(hIndex, 1, h);
      }
    }
    else {
      history.push({bookInfo, number: number, date: new Date()});
    }
    setHistoryNovel(history);
  },
  getHistoryNovel() {
    let history = JSON.parse(window.localStorage.getItem(_historykey_novel));
    if(history) {
      return history.sort((a, b) => {
        let da = new Date(a.date);
        let db = new Date(b.date);
        return db - da;
      })
    }
    else {
      return [];
    }
  },



  getHistoryById(bookId) {
    return this.getHistory().find(item => {
      return item.bookInfo.bookId.toString() === bookId.toString()
    });
  },

  updateHistory(bookId, number) {
    let history = this.getHistory();
    let index = history.findIndex(item => item.bookInfo.bookId.toString() === bookId.toString());
    history[index].number = number;
    history[index].date = new Date();
    setHistory(history);
  },

  getHistoryByIdNovel(bookId) {
    return this.getHistoryNovel().find(item => {
      return item.bookInfo.bookId.toString() === bookId.toString()
    });
  },
  
  updateHistoryNovel(bookId, number) {
    let history = this.getHistoryNovel();
    let index = history.findIndex(item => item.bookInfo.bookId.toString() === bookId.toString());
    history[index].number = number;
    history[index].date = new Date();
    setHistory(history);
  },

};

export default shelfService



// WEBPACK FOOTER //
// ./src/services/shelfService.js